module.exports = __webpack_public_path__ + "static/media/siren-hunts.25c95166.png";